// Policy Page - Change 'Terms Of Service' to use lowercase 'o'
(function() {
   document.addEventListener('DOMContentLoaded', function() {
    console.log("Searching for Policy Title");
    const policyTitle = document.querySelector('.shopify-policy__title h1');
    console.log("Title", policyTitle);
    if (policyTitle) {
      const titles = {
        'terms of service': 'Terms of Service',
        'refund policy': 'Refund Policy',
        'privacy policy': 'Privacy Policy',
        'shipping policy': 'Shipping Policy',
      };
      const current = policyTitle.textContent.trim().toLowerCase();
      console.log("trimming for Policy Title", current);
      if (titles[current]) {
        policyTitle.textContent = titles[current];
      }
    }
   });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
